<template>

    <div>

        <div class="w-full">
            <!--
                <div class="h-20 pb-5"></div>
            -->

            <div class="pb-5 min-h-screen bg-gray-200">
                <div class="container mx-auto pb-10">
                    <div class="border rounded-lg bg-blue-900 mx-auto shadow-lg rounded-lg rounded-t-none">
                        <div class="w-full sm:flex sm:items-center px-6 py-2 " v-if="firstQueryHasReturned">
                            <div class="w-full">
                                <div class="flex flex-wrap -mx-3 mb-2">
                                    <div class="justify-end w-2/12 md:w-1/12 px-2 mb-2 md:mb-0">
                                        <router-link class="block w-12 h-12 bg-blue-500 px-3 my-2 content-center leading-normal rounded-full"
                                            to="/">
                                            <i class="w-full text-white text-lg font-bold leading-tight my-5 fa fa-search" aria-hidden="true"></i>
                                        </router-link>
                                    </div>
                                    <div class="w-10/12 md:w-6/12 px-2 mb-2 md:mb-0" v-if="query.OutboundDate">
                                        <div class="text-white text-lg leading-tight my-2">
                                            {{query.OriginPlace.Name}} ({{query.OriginPlace.Code}}) - {{query.DestinationPlace.Name}} ({{query.DestinationPlace.Code}})
                                        </div>
                                        <div class="text-white text-xs leading-tight my-2">{{numOfPassengers}} 旅客 | {{ getCabinClassName( query.CabinClass ) }}</div>
                                    </div>
                                     <div class="hidden md:block md:w-1/12 px-2 mb-2 md:mb-0">
                                    </div>
                                     <div class="w-6/12 md:w-2/12 px-2 mb-2 md:mb-0" v-if="query.OutboundDate">
                                        <div class="text-white leading-tight my-2">
                                            <a class="text-base cursor-pointer">
                                                <i class="fas fa-caret-left"></i>
                                            </a>
                                            <span class="text-xs mx-4 cursor-pointer">
                                                {{ query.OutboundDate.getMonth() + 1 }} 月 {{ query.OutboundDate.getDate() }} 日 週 {{ translateDay( query.OutboundDate.getDay() ) }}
                                            </span>
                                            <a class="text-base cursor-pointer">
                                                <i class="fas fa-caret-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                     <div class="w-6/12 md:w-2/12 px-2 mb-2 md:mb-0" v-if="query.InboundDate">
                                        <div class="text-white leading-tight my-2">
                                            <a class="text-base">
                                                <i class="fas fa-caret-left cursor-pointer"></i>
                                            </a>
                                            <span class="text-xs mx-4 cursor-pointer">
                                                {{ query.InboundDate.getMonth() + 1 }} 月 {{ query.InboundDate.getDate() }} 日 週 {{ translateDay( query.InboundDate.getDay() ) }}
                                            </span>
                                            <a class="text-base cursor-pointer">
                                                <i class="fas fa-caret-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-10 mx-auto">
                        <div class="flex flex-wrap justify-center my-64" v-if="!firstQueryHasReturned">
                            <Spin :px="64"></Spin>
                        </div>
                        <div class="sm:flex sm:items-center px-6 py-2" v-if="firstQueryHasReturned">
                            <div class="w-full">
                                <div class="flex flex-wrap -mx-3 mb-2">
                                    <div class="w-full md:w-3/12 px-2 mb-2 md:mb-0">
                                        <div class="w-full mb-6">
                                            <div class="w-full border-solid border-b-2 border-gray-300 py-2 text-gray-900 text-lg leading-tight my-2 cursor-pointer"
                                                @click="filterStopsShown = !filterStopsShown">
                                                轉機次數<i class="text-gray-900 text-m float-right fa"
                                                          :class="{
                                                              'fa-chevron-up':filterStopsShown,
                                                              'fa-chevron-down':!filterStopsShown,
                                                          }"></i>
                                            </div>
                                            <div class="w-full py-2 pl-2" v-show="filterStopsShown">
                                                <ul>
                                                    <li class="py-2"
                                                        :class="{
                                                                'opacity-50': !this.availabledStops[0],
                                                                'cursor-not-allowed': !this.availabledStops[0]
                                                            }">
                                                        <label class="inline-flex items-center">
                                                            <input type="checkbox" class="form-checkbox h-4 w-4"
                                                                v-model="selectedStops"
                                                                value="0">
                                                            <span class="ml-3 text-sm text-gray-900">直飛</span>
                                                        </label>
                                                        <div class="ml-2 pl-6 text-xs text-gray-600" v-if="!cheapestItineraryInNoStop">
                                                            無
                                                        </div>
                                                        <div class="ml-2 pl-6 text-xs text-gray-600" v-if="cheapestItineraryInNoStop">
                                                             NT${{ cheapestItineraryInNoStop.lowestPrice | numberFormat }}
                                                        </div>
                                                    </li>
                                                    <li class="py-2"
                                                        :class="{
                                                                'opacity-50': !this.availabledStops[1],
                                                                'cursor-not-allowed': !this.availabledStops[1]
                                                            }">
                                                        <label class="inline-flex items-center">
                                                            <input type="checkbox" class="form-checkbox h-4 w-4"
                                                                v-model="selectedStops"
                                                                value="1">
                                                            <span class="ml-3 text-sm text-gray-900">轉機1次</span>
                                                        </label>
                                                        <div class="ml-2 pl-6 text-xs text-gray-600" v-if="!cheapestItineraryInOneStop">
                                                            無
                                                        </div>
                                                        <div class="ml-2 pl-6 text-xs text-gray-600" v-if="cheapestItineraryInOneStop">
                                                             NT${{ cheapestItineraryInOneStop.lowestPrice | numberFormat }}
                                                        </div>
                                                    </li>
                                                    <li class="py-2"
                                                        :class="{
                                                                'opacity-50': !this.availabledStops[2],
                                                                'cursor-not-allowed': !this.availabledStops[2]
                                                            }">
                                                        <label class="inline-flex items-center">
                                                            <input type="checkbox" class="form-checkbox h-4 w-4"
                                                                v-model="selectedStops"
                                                                value="2">
                                                            <span class="ml-3 text-sm text-gray-900">轉機2次以上</span>
                                                        </label>
                                                        <div class="ml-2 pl-6 text-xs text-gray-600" v-if="!cheapestItineraryInTwoStop">
                                                            無
                                                        </div>
                                                        <div class="ml-2 pl-6 text-xs text-gray-600" v-if="cheapestItineraryInTwoStop">
                                                             NT${{ cheapestItineraryInTwoStop.lowestPrice | numberFormat }}
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="w-full mb-6">
                                            <div class="w-full border-solid border-b-2 border-gray-300 py-2 text-gray-900 text-lg leading-tight my-2 cursor-pointer"
                                                @click="filterCarriersShown = !filterCarriersShown">
                                                航空公司<i class="text-gray-900 text-m float-right fa"
                                                          :class="{
                                                              'fa-chevron-up':filterCarriersShown,
                                                              'fa-chevron-down':!filterCarriersShown,
                                                          }"></i>
                                            </div>
                                            <div class="w-full my-4" v-show="filterCarriersShown">
                                                <a class="text-blue-500 text-xs font-bold"
                                                    :class="{
                                                        'opacity-50': carriersWithCheapestItinerary.length === selectedCarriers.length,
                                                        'cursor-not-allow': carriersWithCheapestItinerary.length >= selectedCarriers.length,
                                                        'cursor-pointer': selectedCarriers.length <  carriersWithCheapestItinerary.length,
                                                    }"
                                                     @click="selectedCarriers = carriersWithCheapestItinerary.map( c => c.Id )">全選</a>
                                                <span class="mx-4 text-gray-400">|</span>
                                                <a class="text-blue-500 text-xs font-bold"
                                                    :class="{
                                                        'opacity-50': selectedCarriers.length === 0,
                                                        'cursor-not-allow': selectedCarriers.length === 0,
                                                        'cursor-pointer': selectedCarriers.length > 0,
                                                    }"
                                                    @click="selectedCarriers = []">取消全選</a>
                                            </div>
                                            <div class="w-full py-2 pl-2" v-show="filterCarriersShown">
                                                <ul>
                                                    <li class="py-2"
                                                        v-for="carrier in carriersWithCheapestItinerary"
                                                        :key="carrier.Id" >
                                                        <label class="inline-flex items-center">
                                                            <input type="checkbox"
                                                                    class="form-checkbox h-4 w-4"
                                                                    v-model="selectedCarriers"
                                                                :value="carrier.Id">
                                                            <span class="ml-3 text-sm text-gray-900">
                                                                {{ carrier.Name }}
                                                            </span>
                                                        </label>
                                                        <div class="ml-2 pl-6 text-xs text-gray-600">
                                                            NT${{ carrier.cheapestItinerary.lowestPrice | numberFormat}}
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-full md:w-1/12 px-2 mb-2 md:mb-0">
                                    </div>
                                    <div class="w-full md:w-8/12 px-2 mb-2 md:mb-0">
                                        <div class="w-full flex flex-wrap my-2">
                                            <div class="w-full flex flex-wrap py-1" v-if="!queryHasCompleted">
                                                 <div class="w-2/12">
                                                    <Spin :px="50"></Spin>
                                                </div>
                                            </div>
                                            <div class="w-full md:w-4/12 py-1">
                                                <p class="text-xs">已顯示 {{itinerariesFiltered.length}} 個結果，總共 {{itineraries.length}} 個結果</p>
                                            </div>
                                            <div class="hidden md:block md:w-4/12">
                                            </div>
                                            <div class="w-2/12 md:w-1/12">
                                                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold pt-3 leading-tight">
                                                    排序方式
                                                </label>
                                            </div>
                                            <div class="w-10/12 md:w-3/12 relative">
                                                <select class="block appearance-none w-full h-10 bg-white border border-gray-300 text-gray-700 py-1 px-4 mx-2 mb-3 p-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                    v-model="selectedSortType">
                                                    <option v-for="(sortTypeName, sortTypeKey) in sortTypes"
                                                        :key="sortTypeKey"
                                                        :value="sortTypeKey">
                                                        {{ sortTypeName }}
                                                    </option>
                                                </select>
                                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 py-2 text-gray-700">
                                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-full flex flex-wrap" v-if="itinerariesFiltered.length > 0">
                                            <div class="w-4/12 px-4 py-3 rounded-lg rounded-r-none cursor-pointer"
                                                :class="{
                                                    'bg-blue-900': selectedSortType == 'best',
                                                    'text-white': selectedSortType == 'best',
                                                    'bg-white': selectedSortType != 'best',
                                                    'text-blue-900': selectedSortType != 'best'
                                                }"
                                                @click="selectedSortType = 'best'">
                                                <p class="text-xs md:text-sm leading-tight my-2">
                                                    最優
                                                </p>
                                                <p class="md:text-2xl font-bold leading-tight my-2"
                                                    :class="{
                                                        'text-white': selectedSortType == 'best',
                                                        'text-blue-500': selectedSortType != 'best',
                                                    }">
                                                    NT${{ bestItinerary.lowestPrice | numberFormat }}
                                                </p>
                                                <p class="text-xs md:text-sm  leading-tight my-2">
                                                    {{ Math.floor(bestItinerary.averageDuration / 60) }}小時{{ Math.ceil( bestItinerary.averageDuration % 60 ) }}分鐘鐘 (平均)
                                                </p>
                                            </div>
                                            <div class="w-4/12 border-gray-300 border-l border-r px-4 py-3 cursor-pointer"
                                                :class="{
                                                    'bg-blue-900': selectedSortType == 'price',
                                                    'text-white': selectedSortType == 'price',
                                                    'bg-white': selectedSortType != 'price',
                                                    'text-blue-900': selectedSortType != 'price'
                                                }"
                                                @click="selectedSortType = 'price'">
                                                <p class="text-xs md:text-sm leading-tight my-2">
                                                    最便宜
                                                </p>
                                                <p class="md:text-2xl font-bold leading-tight my-2"
                                                    :class="{
                                                        'text-white': selectedSortType == 'price',
                                                        'text-blue-500': selectedSortType != 'price',
                                                    }">
                                                    NT${{ cheapestItinerary.lowestPrice | numberFormat }}
                                                </p>
                                                <p class="text-xs md:text-sm leading-tight my-2">
                                                    {{ Math.floor(cheapestItinerary.averageDuration / 60) }}小時{{ Math.ceil( cheapestItinerary.averageDuration % 60 ) }}分鐘鐘 (平均)
                                                </p>
                                            </div>
                                            <div class="w-4/12 bg-white px-4 py-3 rounded-lg rounded-l-none cursor-pointer"
                                                :class="{
                                                    'bg-blue-900': selectedSortType == 'duration',
                                                    'text-white': selectedSortType == 'duration',
                                                    'bg-white': selectedSortType != 'duration',
                                                    'text-blue-900': selectedSortType != 'duration'
                                                }"
                                                @click="selectedSortType = 'duration'">
                                                <p class="text-xs md:text-sm leading-tight my-2">
                                                    最快
                                                </p>
                                                <p class="md:text-2xl font-bold leading-tight my-2"
                                                    :class="{
                                                        'text-white': selectedSortType == 'duration',
                                                        'text-blue-500': selectedSortType != 'duration',
                                                    }">
                                                    NT${{ fastItinerary.lowestPrice | numberFormat}}
                                                </p>
                                                <p class="text-xs md:text-sm leading-tight my-2">
                                                    {{ Math.floor(fastItinerary.averageDuration / 60) }}小時{{ Math.ceil( fastItinerary.averageDuration % 60 ) }}分鐘鐘 (平均)
                                                </p>
                                            </div>
                                        </div>
                                        <div class="w-full flex flex-wrap shadow my-3"
                                            v-for="(itinerary, idx) in itinerariesShown"
                                            :key="idx">
                                            <div class="w-full md:w-8/12 bg-white px-3 py-2 md:rounded-lg md:rounded-r-none cursor-pointer">
                                                <div class="md:hidden w-full flex flex-wrap">
                                                    <p class="text-xs md:text-sm text-gray-700 leading-tight mx-2 my-1">
                                                        {{
                                                            Array.from(
                                                                new Set(
                                                                    itinerary.OutboundLeg.Carriers
                                                                    .concat( itinerary.InboundLeg ? itinerary.InboundLeg.Carriers : [] )
                                                                    .map( carrier => carrier.Name )
                                                                )
                                                            ).join(' + ')
                                                        }}
                                                    </p>
                                                </div>
                                                <div class="w-full flex flex-wrap">
                                                    <div class="hidden md:block md:w-3/12 pt-3">
                                                        <img v-if="itinerary.OutboundLeg.Carriers.length === 1" class="w-30"
                                                            :alt="itinerary.OutboundLeg.Carriers[0].Name"
                                                            :src="itinerary.OutboundLeg.Carriers[0].ImageUrl">
                                                        <span v-if="itinerary.OutboundLeg.Carriers.length > 1" class="text-gray-700 text-sm">
                                                            {{ itinerary.OutboundLeg.Carriers.map( carrier => carrier.Name ).join(' + ') }}
                                                        </span>
                                                    </div>
                                                    <div class="w-full md:w-9/12 pl-3 pt-3 flex flex-wrap">
                                                        <div class="w-3/12">
                                                            <div class="text-gray-900 text-2xl text-right">
                                                                {{ transformDateToHi(itinerary.OutboundLeg.Departure) }}
                                                            </div>
                                                            <div class="text-gray-600 text-base text-right">
                                                                {{ itinerary.OutboundLeg.OriginStation.Code }}
                                                            </div>
                                                        </div>
                                                        <div class="w-6/12">
                                                            <div class="text-gray-700 text-xs text-center mt-2">
                                                                {{ Math.floor(itinerary.OutboundLeg.Duration / 60) }} 小時 {{ Math.ceil( itinerary.OutboundLeg.Duration % 60 ) }} 分鐘
                                                            </div>
                                                            <div class="border-solid border-gray-500 border-t-2 mx-6 my-2"></div>
                                                            <div class="text-blue-500 text-xs text-center" v-if="itinerary.OutboundLeg.Stops.length === 0">直飛</div>
                                                            <div class="text-xs text-center" v-if="itinerary.OutboundLeg.Stops.length >= 1">
                                                                <span class="text-red-600">經停{{itinerary.OutboundLeg.Stops.length}}站</span>
                                                                <span class="text-gray-600">
                                                                    {{ itinerary.OutboundLeg.Stops.map( stop => stop.Code ).join(', ') }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="w-3/12">
                                                            <div class="text-gray-900 text-2xl text-left">
                                                                {{ transformDateToHi(itinerary.OutboundLeg.Arrival) }}
                                                            </div>
                                                            <div class="text-gray-600 text-base text-left">
                                                                {{ itinerary.OutboundLeg.DestinationStation.Code }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="w-full pb-3"
                                                         v-if="itinerary.OutboundLeg.OperatingCarriers.filter( oc => !~itinerary.OutboundLeg.Carriers.map( c => c.Code ).indexOf( oc.Code ) ).length > 0" >
                                                        <span class="text-gray-400 text-xs">
                                                            由 {{
                                                                itinerary.OutboundLeg.OperatingCarriers
                                                                    .filter( (oc, idx) => {
                                                                        return !~itinerary.OutboundLeg.Carriers.map( c => c.Code ).indexOf( oc.Code )
                                                                            && itinerary.OutboundLeg.OperatingCarriers.map( _oc => _oc.Code ).indexOf( oc.Code ) === idx
                                                                        })
                                                                    .map( oc => oc.Name )
                                                                    .join('、')
                                                            }} {{
                                                                itinerary.OutboundLeg.OperatingCarriers
                                                                    .filter( oc => ~itinerary.OutboundLeg.Carriers.map( c => c.Code ).indexOf( oc.Code ) )
                                                                    .length === 0 ? '' : '部分'
                                                             }}營運
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="w-full flex flex-wrap" v-if="itinerary.InboundLeg">
                                                    <div class="hidden md:block md:w-3/12 pt-3">
                                                        <img v-if="itinerary.InboundLeg.Carriers.length === 1" class="w-30"
                                                            :alt="itinerary.InboundLeg.Carriers[0].Name"
                                                            :src="itinerary.InboundLeg.Carriers[0].ImageUrl">
                                                        <span v-if="itinerary.InboundLeg.Carriers.length > 1" class="text-gray-700 text-sm">
                                                            {{ itinerary.InboundLeg.Carriers.map( carrier => carrier.Name ).join(' + ') }}
                                                        </span>
                                                    </div>
                                                    <div class="w-full md:w-9/12 pl-3 pt-3 flex flex-wrap">
                                                        <div class="w-3/12">
                                                            <div class="text-gray-900 text-2xl text-right">
                                                                {{ transformDateToHi(itinerary.InboundLeg.Departure) }}
                                                            </div>
                                                            <div class="text-gray-600 text-base text-right">
                                                                {{ itinerary.InboundLeg.OriginStation.Code }}
                                                            </div>
                                                        </div>
                                                        <div class="w-6/12">
                                                            <div class="text-gray-700 text-xs text-center mt-2">
                                                                {{ Math.floor(itinerary.InboundLeg.Duration / 60) }}小時{{ Math.ceil( itinerary.InboundLeg.Duration % 60 ) }}分鐘
                                                            </div>
                                                            <div class="border-solid border-gray-500 border-t-2 mx-6 my-2"></div>
                                                            <div class="text-blue-500 text-xs text-center" v-if="itinerary.InboundLeg.Stops.length === 0">直飛</div>
                                                            <div class="text-xs text-center" v-if="itinerary.InboundLeg.Stops.length >= 1">
                                                                <span class="text-red-600">經停{{itinerary.InboundLeg.Stops.length}}站</span>
                                                                <span class="text-gray-600">
                                                                    {{ itinerary.InboundLeg.Stops.map( stop => stop.Code ).join(', ') }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="w-3/12">
                                                            <div class="text-gray-900 text-2xl text-left">
                                                                {{ transformDateToHi(itinerary.InboundLeg.Arrival) }}
                                                            </div>
                                                            <div class="text-gray-600 text-base text-left">
                                                                {{ itinerary.InboundLeg.DestinationStation.Code }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="w-full pb-3"
                                                         v-if="itinerary.InboundLeg.OperatingCarriers.filter( oc => !~itinerary.InboundLeg.Carriers.map( c => c.Code ).indexOf( oc.Code ) ).length > 0" >
                                                        <span class="text-gray-400 text-xs">
                                                            由 {{
                                                                itinerary.InboundLeg.OperatingCarriers
                                                                    .filter( (oc, idx) => {
                                                                        return !~itinerary.InboundLeg.Carriers.map( c => c.Code ).indexOf( oc.Code )
                                                                            && itinerary.InboundLeg.OperatingCarriers.map( _oc => _oc.Code ).indexOf( oc.Code ) === idx
                                                                        })
                                                                    .map( oc => oc.Name )
                                                                    .join('、')
                                                            }} {{
                                                                itinerary.InboundLeg.OperatingCarriers
                                                                    .filter( oc => ~itinerary.InboundLeg.Carriers.map( c => c.Code ).indexOf( oc.Code ) )
                                                                    .length === 0 ? '' : '部分'
                                                             }}營運
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="w-full md:w-4/12 flex flex-wrap items-center bg-white px-3 py-2 md:rounded-lg md:rounded-l-none border-t md:border-t-0 md:border-l border-gray-300 cursor-pointer">
                                                <p class="w-full text-blue-900 text-xs leading-tight text-center">
                                                    {{ itinerary.PricingOptions.length }} 個優惠，價格低至
                                                </p>
                                                <div class="w-full flex flex-wrap items-center justify-center">
                                                        <div class="mr-2" v-if="!queryHasCompleted">
                                                            <Spin :px="20"></Spin>
                                                        </div>
                                                        <p class="text-black text-2xl font-bold text-center">
                                                            NT${{ Math.ceil( Math.min.apply(null, itinerary.PricingOptions.map( po => po.Price )) / numOfPassengers ) | numberFormat }}
                                                        </p>
                                                </div>
                                                <p class="w-full text-gray-600 text-sm leading-tight text-center my-2" v-if="numOfPassengers > 1">
                                                    總價 NT${{ Math.min.apply(null, itinerary.PricingOptions.map( po => po.Price )) }}
                                                </p>
                                                <button class="relative mx-auto bg-blue-500 text-white text-xl flex content-center font-bold px-5 py-2 rounded-lg leading-tight my-2"
                                                    @click="showItineraryDetail(itinerary)">
                                                    <span class="w-full text-center">
                                                        選擇
                                                        <i class="fa fa-arrow-right text-sm mx-1" aria-hidden="true"></i>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="w-full flex flex-wrap my-10">
                                            <button class="relative mx-auto w-40 px-2 py-2 rounded-lg center content-center border-2 border-white text-blue-500"
                                                v-if="maxNumOfItinerariesShown < itinerariesFiltered.length"
                                                @click="maxNumOfItinerariesShown += maxNumOfItinerariesShown > 40 ? 999999 : 10 ">
                                                顯示更多結果
                                            </button>
                                        </div>
                                        <div class="w-full flex flex-wrap justify-center my-10 px-4 py-4 rounded-lg"
                                            v-if="queryHasCompleted && itineraries.length === 0">
                                            <p class="w-full md:w-8/12 text-gray-700 text-lg md:text-2xl">
                                                很抱歉，無法依據您的查詢條件找到任何航班。
                                            </p>
                                            <p class="w-full md:w-8/12 text-gray-700 text-lg md:text-2xl">
                                                建議您可<router-link class="text-blue-500" to="/">調整條件後再次查詢</router-link>。
                                            </p>
                                            <div class="w-full md:w-8/12">
                                                <img class="w-full" src="../assets/img/undraw_empty_xct9.svg"/>
                                            </div>
                                        </div>
                                        <div class="w-full flex flex-wrap justify-center my-10 px-4 py-4 rounded-lg"
                                            v-show="itineraries.length > 0 && itinerariesFiltered.length === 0">
                                            <h4 class="w-full text-gray-700 text-lg md:text-2xl my-2 text-center">很抱歉，沒有任何航班符合您的篩選條件。</h4>
                                            <div class="w-full md:w-8/12">
                                                <img class="w-full" src="../assets/img/undraw_signal_searching_bhpc.svg"/>
                                            </div>
                                        </div>
                                        <div class="w-full my-10 text-xs">
                                            <p class="text-gray-900 my-2">
                                                <span class="font-bold">以上價格為每日更新</span>，實際票價可能根據訂票時的餘票數量有所變動。
                                            </p>
                                            <p class="my-2">
                                                <span class="text-gray-900 font-bold">
                                                    托運行李？
                                                </span>
                                                <a class="text-blue-500"
                                                    href="https://www.skyscanner.com.tw/airlinefees"
                                                    target="_blank">
                                                    可能需要收取額外行李費
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="fixed inset-0 w-full min-h-screen max-h-screen z-20" v-if="detailShown">

            <div class="fixed w-full bg-white z-40 h-12 shadow">
                <div class="w-full flex">
                    <div class="w-6/12 max-w-5xl">
                        <h2 class="mx-5 text-gray-700 text-xl h-12 leading-loose font-bold">
                            詳細資訊
                        </h2>
                    </div>
                    <div class="w-4/12">
                    </div>
                    <div class="w-2/12 flex flex-row-reverse">
                        <button class="px-3 text-gray-700 text-3xl font-bold"
                            @click="closeDetail">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="bg-gray-200 pt-12 min-h-screen max-h-screen overflow-y-auto">
                <div class="container mx-auto">
                    <div class="bg-white mx-auto ">
                        <div class="w-full flex">
                            <div class="w-full md:w-7/12 min-h-screen border-gray-300 border-r px-6 py-6">
                                <div class="w-full my-2">
                                    <div class="w-full py-2 flex">
                                        <div class="w-full md:w-8/12">
                                            <h3 class="leading-normal">
                                                <span class="font-bold text-gray-700">去程</span>
                                                <span class="mx-1"></span>
                                                <span class="mx-1 text-gray-600">{{ detailedItinerary.OutboundLeg.Departure.getFullYear() }} 年 {{ detailedItinerary.OutboundLeg.Departure.getMonth() + 1 }} 月 {{ detailedItinerary.OutboundLeg.Departure.getDate() }} 日 週{{ translateDay(detailedItinerary.OutboundLeg.Departure.getDay()) }}</span>
                                            </h3>
                                        </div>
                                        <div class="hidden md:block md:w-4/12">
                                            <p class="text-gray-500 text-xs text-right leading-normal">所有時間都是當地時間</p>
                                        </div>
                                    </div>
                                    <div class="w-full border border-gray-300 rounded-lg rounded-b-none px-2 py-3 flex flex-wrap cursor-pointer"
                                        @click="detail.OutboundSegmentShown = !detail.OutboundSegmentShown">
                                        <div class="flex flex-wrap w-full md:w-3/12 py-2">
                                            <img class="w-16"
                                                v-if="detailedItinerary.OutboundLeg.Carriers.length === 1"
                                                :alt="detailedItinerary.OutboundLeg.Carriers[0].Name"
                                                :src="detailedItinerary.OutboundLeg.Carriers[0].ImageUrl">
                                            <span class="text-gray-700 text-sm inline-block md:hidden mt-2"
                                                v-if="detailedItinerary.OutboundLeg.Carriers.length === 1">
                                                {{ detailedItinerary.OutboundLeg.Carriers[0].Name }}
                                            </span>
                                            <span v-if="detailedItinerary.OutboundLeg.Carriers.length > 1" class="text-gray-700 text-sm">
                                                {{ detailedItinerary.OutboundLeg.Carriers.map( carrier => carrier.Name ).join(' + ') }}
                                            </span>
                                        </div>
                                        <div class="flex flex-wrap w-full md:w-6/12">
                                            <div class="w-3/12">
                                                <div class="text-gray-900 text-2xl text-right">
                                                    {{ transformDateToHi( detailedItinerary.OutboundLeg.Departure ) }}
                                                </div>
                                                <div class="text-gray-600 text-base text-right">
                                                    {{ detailedItinerary.OutboundLeg.OriginStation.Code }}
                                                </div>
                                            </div>
                                            <div class="w-6/12">
                                                <div class="text-gray-700 text-xs text-center mt-2">
                                                    {{ Math.floor(detailedItinerary.OutboundLeg.Duration / 60) }}小時{{ Math.ceil( detailedItinerary.OutboundLeg.Duration % 60 ) }}分鐘
                                                </div>
                                                <div class="border-solid border-gray-500 border-t-2 mx-6 my-2"></div>
                                                <div class="text-blue-500 text-sm text-center" v-if="detailedItinerary.OutboundLeg.Stops.length === 0">直飛</div>
                                                <div class="text-xs text-center" v-if="detailedItinerary.OutboundLeg.Stops.length >= 1">
                                                    <span class="text-red-600">經停{{detailedItinerary.OutboundLeg.Stops.length}}站</span>
                                                    <span class="text-gray-600">
                                                        {{ detailedItinerary.OutboundLeg.Stops.map( stop => stop.Code ).join(', ') }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="w-3/12">
                                                <div class="text-gray-900 text-2xl text-left">
                                                   {{ transformDateToHi( detailedItinerary.OutboundLeg.Arrival ) }}
                                                </div>
                                                <div class="text-gray-600 text-base text-left">
                                                     {{ detailedItinerary.OutboundLeg.DestinationStation.Code }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-2/12">
                                        </div>
                                        <div class="w-full md:w-1/12 flex justify-center py-2 md-py-6">
                                            <i class="text-gray-700 fa fa-chevron-down"
                                                :class="{
                                                    'fa-chevron-up':detail.OutboundSegmentShown,
                                                    'fa-chevron-down':!detail.OutboundSegmentShown
                                                }" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                    <div class="w-full border border-gray-300 rounded-lg rounded-t-none px-2 py-4"
                                        v-show="detail.OutboundSegmentShown">
                                        <template v-for="(segment, idx) in detailedItinerary.OutboundLeg.Segments">
                                            <div class="w-full"
                                                :key="`segment${idx}`">
                                                <div class="w-full flex">
                                                    <div class="md:w-3/12">
                                                    </div>
                                                    <div class="w-full md:w-9/12">
                                                        <span class="text-gray-700 text-xs">
                                                            {{ segment.Carrier.Name }} {{ segment.Carrier.Code }}{{ segment.FlightNumber }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="w-full flex">
                                                    <div class="hidden md:block w-3/12 pt-5">
                                                        <span class="text-gray-700 text-xs px-2">
                                                            {{ Math.floor(segment.Duration / 60) }} 小時 {{ Math.ceil( segment.Duration % 60 ) }} 分鐘
                                                        </span>
                                                    </div>
                                                    <div class="w-1/12 flex items-center">
                                                        <div class="w-8/12 border-r-2 h-20 md:h-8 border-gray-400">
                                                        </div>
                                                    </div>
                                                    <div class="w-11/12 md:w-8/12">
                                                        <div class="w-full text-base py-1">
                                                            <span class="text-gray-700">{{ transformDateToHi( segment.DepartureDateTime ) }}</span>
                                                            <span class="mx-10 md:mx-2"></span>
                                                            <span class="text-gray-900">{{ segment.OriginStation.Code }} {{ segment.OriginStation.Name }}</span>
                                                        </div>
                                                        <div class="block md:hidden w-full text-gray-900 text-base py-1">
                                                            <i class="text-gray-700 fa fa-clock-o" aria-hidden="true"></i>
                                                            <span class="text-gray-700 text-xs px-2">
                                                                {{ Math.floor(segment.Duration / 60) }} 小時 {{ Math.ceil( segment.Duration % 60 ) }} 分鐘
                                                            </span>
                                                        </div>
                                                        <div class="w-full text-gray-900 text-base py-1">
                                                            <span class="text-gray-700">{{ transformDateToHi( segment.ArrivalDateTime ) }}</span>
                                                            <span class="mx-10 md:mx-2"></span>
                                                            <span class="text-gray-900">{{ segment.DestinationStation.Code }} {{ segment.DestinationStation.Name }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="w-full bg-gray-200 text-red-600 my-1 py-2"
                                                v-if="detailedItinerary.OutboundLeg.Segments[idx+1]"
                                                :key="`stop${idx}`">
                                                <div class="w-full flex py-2">
                                                    <div class="w-3/12">
                                                        <span class="text-xs px-2">
                                                            {{ Math.floor( ( detailedItinerary.OutboundLeg.Segments[idx+1].DepartureDateTime - segment.ArrivalDateTime ) / 1000 / 60 / 60) }} 小時 {{ Math.ceil( ( detailedItinerary.OutboundLeg.Segments[idx+1].DepartureDateTime - segment.ArrivalDateTime ) / 1000 / 60 % 60 ) }} 分鐘
                                                        </span>
                                                    </div>
                                                    <div class="w-1/12">
                                                    </div>
                                                    <div class="w-8/12">
                                                        <div class="w-full text-sm">
                                                            <span>{{ segment.DestinationStation.Code == detailedItinerary.OutboundLeg.Segments[idx+1].OriginStation.Code ? '機場轉機' : '變更機場' }}</span>
                                                            <span class="mx-2"></span>
                                                            <span class="font-bold"
                                                                  v-if=" Math.floor( ( detailedItinerary.OutboundLeg.Segments[idx+1].DepartureDateTime - segment.ArrivalDateTime ) / 1000 / 60 / 60) >= 3">長時間等待</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="w-full flex px-2 pt-4 mb-2">
                                            <p class="text-gray-900 text-xs">
                                                <span class="font-bold">抵達：</span>
                                                <span>{{ detailedItinerary.OutboundLeg.Arrival.getFullYear() }} 年 {{ detailedItinerary.OutboundLeg.Arrival.getMonth() + 1 }} 月 {{ detailedItinerary.OutboundLeg.Arrival.getDate() }}日 週{{ translateDay( detailedItinerary.OutboundLeg.Arrival.getDay() ) }}</span>
                                                <span class="mx-2">|</span>
                                                <span class="font-bold">
                                                    旅行總時間：
                                                </span>
                                                <span>
                                                    {{ Math.floor(detailedItinerary.OutboundLeg.Duration / 60) }} 小時 {{ Math.ceil( detailedItinerary.OutboundLeg.Duration % 60 ) }} 分鐘
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-full my-2"
                                    v-if="detailedItinerary.InboundLeg">
                                    <div class="w-full py-2 flex">
                                        <div class="w-full md:w-8/12">
                                            <h3 class="leading-normal">
                                                <span class="font-bold text-gray-700">回程</span>
                                                <span class="mx-1"></span>
                                                <span class="mx-1 text-gray-600">{{ detailedItinerary.InboundLeg.Departure.getFullYear() }} 年 {{ detailedItinerary.InboundLeg.Departure.getMonth() + 1 }} 月 {{ detailedItinerary.InboundLeg.Departure.getDate() }} 日 週{{ translateDay(detailedItinerary.InboundLeg.Departure.getDay()) }}</span>
                                            </h3>
                                        </div>
                                        <div class="hidden md:block md:w-4/12">
                                        </div>
                                    </div>
                                    <div class="w-full border border-gray-300 rounded-lg rounded-b-none px-2 py-3 flex flex-wrap cursor-pointer"
                                        @click="detail.InboundSegmentShown = !detail.InboundSegmentShown">
                                        <div class="flex flex-wrap w-full md:w-3/12 py-2">
                                            <img class="w-16"
                                                v-if="detailedItinerary.InboundLeg.Carriers.length === 1"
                                                :alt="detailedItinerary.InboundLeg.Carriers[0].Name"
                                                :src="detailedItinerary.InboundLeg.Carriers[0].ImageUrl">
                                            <span class="text-gray-700 text-sm inline-block md:hidden mt-2"
                                                v-if="detailedItinerary.InboundLeg.Carriers.length === 1">
                                                {{ detailedItinerary.InboundLeg.Carriers[0].Name }}
                                            </span>
                                            <span v-if="detailedItinerary.InboundLeg.Carriers.length > 1" class="text-gray-700 text-sm">
                                                {{ detailedItinerary.InboundLeg.Carriers.map( carrier => carrier.Name ).join(' + ') }}
                                            </span>
                                        </div>
                                        <div class="flex flex-wrap w-full md:w-6/12">
                                            <div class="w-3/12">
                                                <div class="text-gray-900 text-2xl text-right">
                                                    {{ transformDateToHi( detailedItinerary.InboundLeg.Departure ) }}
                                                </div>
                                                <div class="text-gray-600 text-base text-right">
                                                    {{ detailedItinerary.InboundLeg.OriginStation.Code }}
                                                </div>
                                            </div>
                                            <div class="w-6/12">
                                                <div class="text-gray-700 text-xs text-center mt-2">
                                                    {{ Math.floor(detailedItinerary.InboundLeg.Duration / 60) }}小時{{ Math.ceil( detailedItinerary.InboundLeg.Duration % 60 ) }}分鐘
                                                </div>
                                                <div class="border-solid border-gray-500 border-t-2 mx-6 my-2"></div>
                                                <div class="text-blue-500 text-sm text-center" v-if="detailedItinerary.InboundLeg.Stops.length === 0">直飛</div>
                                                <div class="text-xs text-center" v-if="detailedItinerary.InboundLeg.Stops.length >= 1">
                                                    <span class="text-red-600">經停{{detailedItinerary.InboundLeg.Stops.length}}站</span>
                                                    <span class="text-gray-600">
                                                        {{ detailedItinerary.InboundLeg.Stops.map( stop => stop.Code ).join(', ') }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="w-3/12">
                                                <div class="text-gray-900 text-2xl text-left">
                                                   {{ transformDateToHi( detailedItinerary.InboundLeg.Arrival ) }}
                                                </div>
                                                <div class="text-gray-600 text-base text-left">
                                                     {{ detailedItinerary.InboundLeg.DestinationStation.Code }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-2/12">
                                        </div>
                                        <div class="w-full md:w-1/12 flex justify-center py-2 md-py-6">
                                            <i class="text-gray-700 fa fa-chevron-down"
                                                :class="{
                                                    'fa-chevron-up':detail.InboundSegmentShown,
                                                    'fa-chevron-down':!detail.InboundSegmentShown
                                                }" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                    <div class="w-full border border-gray-300 rounded-lg rounded-t-none px-2 py-4"
                                        v-show="detail.InboundSegmentShown">
                                        <template v-for="(segment, idx) in detailedItinerary.InboundLeg.Segments">
                                            <div class="w-full"
                                                :key="`segment${idx}`">
                                                <div class="w-full flex">
                                                    <div class="md:w-3/12">
                                                    </div>
                                                    <div class="w-full md:w-9/12">
                                                        <span class="text-gray-700 text-xs">
                                                            {{ segment.Carrier.Name }} {{ segment.Carrier.Code }}{{ segment.FlightNumber }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="w-full flex">
                                                    <div class="hidden md:block w-3/12 pt-5">
                                                        <span class="text-gray-700 text-xs px-2">
                                                            {{ Math.floor(segment.Duration / 60) }} 小時 {{ Math.ceil( segment.Duration % 60 ) }} 分鐘
                                                        </span>
                                                    </div>
                                                    <div class="w-1/12 flex items-center">
                                                        <div class="w-8/12 border-r-2 h-20 md:h-8 border-gray-400">
                                                        </div>
                                                    </div>
                                                    <div class="w-11/12 md:w-8/12">
                                                        <div class="w-full text-base py-1">
                                                            <span class="text-gray-700">{{ transformDateToHi( segment.DepartureDateTime ) }}</span>
                                                            <span class="mx-10 md:mx-2"></span>
                                                            <span class="text-gray-900">{{ segment.OriginStation.Code }} {{ segment.OriginStation.Name }}</span>
                                                        </div>
                                                        <div class="block md:hidden w-full text-gray-900 text-base py-1">
                                                            <i class="text-gray-700 fa fa-clock-o" aria-hidden="true"></i>
                                                            <span class="text-gray-700 text-xs px-2">
                                                                {{ Math.floor(segment.Duration / 60) }} 小時 {{ Math.ceil( segment.Duration % 60 ) }} 分鐘
                                                            </span>
                                                        </div>
                                                        <div class="w-full text-gray-900 text-base py-1">
                                                            <span class="text-gray-700">{{ transformDateToHi( segment.ArrivalDateTime ) }}</span>
                                                            <span class="mx-10 md:mx-2"></span>
                                                            <span class="text-gray-900">{{ segment.DestinationStation.Code }} {{ segment.DestinationStation.Name }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="w-full bg-gray-200 text-red-600 my-1 py-2"
                                                v-if="detailedItinerary.InboundLeg.Segments[idx+1]"
                                                :key="`stop${idx}`">
                                                <div class="w-full flex py-2">
                                                    <div class="w-3/12">
                                                        <span class="text-xs px-2">
                                                            {{ Math.floor( ( detailedItinerary.InboundLeg.Segments[idx+1].DepartureDateTime - segment.ArrivalDateTime ) / 1000 / 60 / 60) }} 小時 {{ Math.ceil( ( detailedItinerary.InboundLeg.Segments[idx+1].DepartureDateTime - segment.ArrivalDateTime ) / 1000 / 60 % 60 ) }} 分鐘
                                                        </span>
                                                    </div>
                                                    <div class="w-1/12">
                                                    </div>
                                                    <div class="w-8/12">
                                                        <div class="w-full text-sm">
                                                            <span>{{ segment.DestinationStation.Code == detailedItinerary.InboundLeg.Segments[idx+1].OriginStation.Code ? '機場轉機' : '變更機場' }}</span>
                                                            <span class="mx-2"></span>
                                                            <span class="font-bold"
                                                                    v-if="Math.floor( ( detailedItinerary.InboundLeg.Segments[idx+1].DepartureDateTime - segment.ArrivalDateTime ) / 1000 / 60 / 60) >= 3 ">長時間等待</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="w-full flex px-2 pt-4 mb-2">
                                            <p class="text-gray-900 text-xs">
                                                <span class="font-bold">抵達：</span>
                                                <span>{{ detailedItinerary.InboundLeg.Arrival.getFullYear() }} 年 {{ detailedItinerary.InboundLeg.Arrival.getMonth() + 1 }} 月 {{ detailedItinerary.InboundLeg.Arrival.getDate() }}日 週{{ translateDay( detailedItinerary.InboundLeg.Arrival.getDay() ) }}</span>
                                                <span class="mx-2">|</span>
                                                <span class="font-bold">
                                                    旅行總時間：
                                                </span>
                                                <span>
                                                    {{ Math.floor(detailedItinerary.InboundLeg.Duration / 60) }} 小時 {{ Math.ceil( detailedItinerary.InboundLeg.Duration % 60 ) }} 分鐘
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-full my-8">
                                    <h3 class="text-gray-700 text-2xl font-bold leading-normal">預定您的機票</h3>
                                    <p class="text-gray-700 text-xs leading-normal">經濟艙，1位成人</p>
                                    <div class="w-full flex border border-gray-500 rounded-lg mt-4 px-2 py-2 cursor-pointer"
                                        @click="detail.infoBeforeOrderShown = !detail.infoBeforeOrderShown"
                                        :class="{
                                            'rounded-b-none':detail.infoBeforeOrderShown,
                                            'border-b-0': detail.infoBeforeOrderShown,
                                        }">
                                        <div class="w-11/12">
                                            <p class="text-gray-700 text-base leading-normal">
                                                <i class="fa fa-info-circle mx-2" aria-hidden="true"></i>
                                                <span>訂票前須知</span>
                                            </p>
                                        </div>
                                        <div class="w-1/12">
                                            <i class="text-gray-700 fa fa-chevron-down"
                                                :class="{
                                                    'fa-chevron-up':detail.infoBeforeOrderShown,
                                                    'fa-chevron-down':!detail.infoBeforeOrderShown
                                                }" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                    <div class="w-full px-4 border border-gray-500 border-t-0 rounded-lg rounded-t-none text-xs text-gray-700 leading-normal" v-show="detail.infoBeforeOrderShown">
                                        <p class="py-2">
                                            雖然所示的價格一定包含預估的所有必要稅金與費用，但是訂票前請記得到訂票網站上<span class="font-bold">檢查完整機票資料、最終價格以及條款與條件</span>。
                                        </p>
                                        <ul class="list-disc  pl-4">
                                            <li class="my-2">
                                                <p class="font-bold">檢查是否有額外費用</p>
                                                <p>有些航空公司/旅行社會針對<span class="font-bold">行李、保險或信用卡</span>付款方式收取額外費用。檢視<a class="text-blue-500" href="https://www.skyscanner.com.tw/airlinefees" target="_blank">航空公司費用</a></p>
                                            </li>
                                            <li class="my-2">
                                                <p class="font-bold">檢查 12 到 16 歲乘客適用的條款與條件</p>
                                                <p>未成年乘客獨自搭乘有其他相關規定。</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="w-full">
                                    <div class="w-full flex border-b border-gray-300 py-8"
                                        v-for="(priceOption, idx) in detailedItinerary.PricingOptions"
                                        :key="idx">
                                        <div class="w-7/12">
                                            <h6 class="text-gray-700 text-base leading-normal">
                                                {{ priceOption.Agents[0].Name }}
                                            </h6>
                                        </div>
                                        <div class="w-5/12 flex flex-wrap">
                                            <div class="w-full md:w-6/12">
                                                <h6 class="text-black text-lg font-bold text-center leading-normal mt-2">
                                                    NT${{ priceOption.Price | numberFormat }}
                                            </h6>
                                            </div>
                                            <div class="w-full md:w-6/12">
                                                <a class="w-full bg-blue-500 text-white text-xl flex content-center font-bold ml-2 px-3 py-2 rounded-lg leading-tight"
                                                    target="_blank"
                                                    rel="nofollow"
                                                    :href="priceOption.DeeplinkUrl">
                                                    <span class="w-full text-center">
                                                        選擇
                                                        <i class="fa fa-arrow-right text-sm mx-1" aria-hidden="true"></i>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="hidden md:block md:w-5/12">
                                <img class="mt-64" src="./../assets/img/undraw_airport_2581.svg">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <ErrorMessage :messages="errorMessages"
                        v-show="errorMessages.length"
                        v-on:confirm="confirmErrorMessages"/>

    </div>

</template>

<script>

import axios from 'axios'
import Spin from './Spin.vue';
import ErrorMessage from './ErrorMessage.vue';

export default {
  components:{
      Spin,
      ErrorMessage
  },
  data(){
      return{
            resultId: parseInt(this.$route.params.session),

            errorMessages:[],

            cabinClasses:{
              'economy': '經濟艙',
              'eremiumEconomy': '高端經濟艙',
              'business': '商務艙',
              'first': '頭等艙',
            },
            queryHasCompleted: false,
            query:{},
            carriersMap:[],
            itineraries:[],
            selectedCarriers:[],
            selectedSortType:'best',
            selectedStops:[0,1,2],
            availabledStops:{
                0:false,
                1:false,
                2:false,
            },
            maxNumOfItinerariesShown: 10,

            filterCarriersShown: true,
            filterStopsShown: true,


            detail:{
                OutboundSegmentShown: false,
                InboundSegmentShown: false,
                infoBeforeOrderShown: false,
            },
            detailShown: false,
            detailedItinerary:{},
        };
  },
  computed:{
      sortTypes(){
        let types = {
                'best': '最優',
                'price': '最便宜優先',
                'duration': '最快優先',
                'outbounddeparttime': '去程：出發時間',
            };
        if( this.query.InboundDate ) types.inbounddeparttime = '回程：出發時間';
        return types;
      },
      firstQueryHasReturned(){
          return Object.keys(this.query).length > 0;
      },
      itinerariesFiltered(){
          const selectedStops      = this.selectedStops.map( s => +s );
          const selectedCarriers   = this.selectedCarriers.map( c => +c );
          const includeCarriersMix = ~this.selectedCarriers.indexOf(0);
          return this.itineraries
                    .filter( function(itinerary){
                        return ~selectedStops.indexOf(itinerary.maxNumOfStops)
                            && (
                                ~selectedCarriers.indexOf( itinerary.onlyCarrierId )
                                || ( includeCarriersMix ? !itinerary.onlyCarrierId : false )
                            );
                    });
      },
      itinerariesSorted(){

          let sortFunc;

          const sortByPriceFunc = function(i1, i2){
                    return i1.lowestPrice > i2.lowestPrice ? 1 : -1;
          };

          const sortByDuration = function(i1, i2){
                    return i1.lowestPrice > i2.lowestPrice ? 1 : -1;
          };

          switch(this.selectedSortType){
              case 'best':
                return this.itinerariesFiltered;
              case 'price':
                sortFunc = function(i1, i2){
                    switch(true){
                        case i1.lowestPrice === i2.lowestPrice:
                            return sortByDuration(i1, i2)
                        default:
                            return i1.lowestPrice > i2.lowestPrice ? 1 : -1;
                    }
                };
                break;
              case 'duration':
                sortFunc = function(i1, i2){
                    switch(true){
                        case i1.averageDuration === i2.averageDuration:
                            return sortByPriceFunc(i1, i2);
                        default:
                            return i1.averageDuration > i2.averageDuration ? 1 : -1;
                    }
                };
                break;
              case 'outbounddeparttime':
                sortFunc = function(i1, i2){
                    return i1.OutboundLeg.Departure > i2.OutboundLeg.Departure ? 1 : -1;
                };
                break;
              case 'inbounddeparttime':
                sortFunc = function(i1, i2){
                    return i1.InboundLeg.Departure > i2.InboundLeg.Departure ? 1 : -1;
                };
                break;
          }
          const itinerariesCopied = this.itinerariesFiltered.slice();

          itinerariesCopied.sort(sortFunc);

          return itinerariesCopied;
      },
      itinerariesShown (){
          const maxNumOfItinerariesShown = this.maxNumOfItinerariesShown;
          return this.itinerariesSorted.filter( (itinerary, idx) => idx <= maxNumOfItinerariesShown );
      },
      numOfPassengers(){
          return this.query.hasOwnProperty('Adults') ? this.query.Adults + this.query.Children + this.query.Infants : 0;
      },
      bestItinerary() {
          return this.itinerariesFiltered[0];
          //this.itinerariesFiltered.reduce( ( bestItinerary, itinerary ) => !bestItinerary || ( itinerary.lowestPrice / itinerary.averageDuration ) < ( bestItinerary.lowestPrice / bestItinerary.averageDuration ) ? itinerary : bestItinerary, null );
      },
      cheapestItinerary() {
          return this.itinerariesFiltered.reduce( ( cheapestItinerary, itinerary ) => !cheapestItinerary || itinerary.lowestPrice < cheapestItinerary.lowestPrice ? itinerary : cheapestItinerary, null );
      },
      fastItinerary() {
          return this.itinerariesFiltered.reduce( ( fastItinerary, itinerary ) => !fastItinerary || itinerary.averageDuration < fastItinerary.averageDuration || ( itinerary.averageDuration == fastItinerary.averageDuration && itinerary.lowestPrice < fastItinerary.lowestPrice ) ? itinerary : fastItinerary, null );
      },
      cheapestItineraryInNoStop(){
          return this.itineraries.filter(itinerary => itinerary.maxNumOfStops === 0)
                                 .reduce((cheapestItinerary, itinerary) => !cheapestItinerary || itinerary.lowestPrice < cheapestItinerary.lowestPrice ? itinerary : cheapestItinerary, null);
      },
      cheapestItineraryInOneStop(){
          return this.itineraries.filter(itinerary => itinerary.maxNumOfStops === 1)
                                 .reduce((cheapestItinerary, itinerary) => !cheapestItinerary || itinerary.lowestPrice < cheapestItinerary.lowestPrice ? itinerary : cheapestItinerary, null);
      },
      cheapestItineraryInTwoStop(){
          return this.itineraries.filter(itinerary => itinerary.maxNumOfStops === 2)
                                 .reduce((cheapestItinerary, itinerary) => !cheapestItinerary || itinerary.lowestPrice < cheapestItinerary.lowestPrice ? itinerary : cheapestItinerary, null);
      },

      carriersWithCheapestItinerary(){
          return this.carriersMap.filter( c => !!c.cheapestItinerary );
      }
  },
  created(){
     this.getResult(this.resultId);
  },
  methods:{

      confirmErrorMessages(){
          this.$router.push({ path: '/' });
      },
      getCabinClassName(cabinClassId){
          return this.cabinClasses[cabinClassId];
      },
      getResult(resultId){
          axios.get(`${process.env.VUE_APP_API_URL}/api/search/price/${resultId}`)
               .then( response => {

                    console.log(response)
                    const result = response.data;

                    this.queryHasCompleted = result.is_completed;
                    if(!result.is_completed) setTimeout(function(){this.getResult(resultId);}.bind(this), 5000);
                    if(!result.data) return;
                    const query = result.data.query;
                    query.OutboundDate = new Date(query.OutboundDate);
                    query.InboundDate  = query.InboundDate ? new Date(query.InboundDate) : null;
                    this.query       = query;
                    const numOfPassengers = this.numOfPassengers;
                    const isOneWay        = !query.InboundDate;

                    this.availabledStops[0] = false;
                    this.availabledStops[1] = false;
                    this.availabledStops[2] = false;

                    this.itineraries = result.data.itineraries.map( itinerary => {

                        if(itinerary.InboundLeg){
                            itinerary.InboundLeg.Arrival = new Date(itinerary.InboundLeg.Arrival);
                            itinerary.InboundLeg.Departure = new Date(itinerary.InboundLeg.Departure);
                            itinerary.InboundLeg.Segments  = itinerary.InboundLeg.Segments.map( segment => {
                                segment.ArrivalDateTime = new Date(segment.ArrivalDateTime);
                                segment.DepartureDateTime = new Date(segment.DepartureDateTime);
                                return segment;
                            } );
                        }
                            itinerary.OutboundLeg.Arrival = new Date(itinerary.OutboundLeg.Arrival);
                            itinerary.OutboundLeg.Departure = new Date(itinerary.OutboundLeg.Departure);
                            itinerary.OutboundLeg.Segments  = itinerary.OutboundLeg.Segments.map( segment => {
                                segment.ArrivalDateTime = new Date(segment.ArrivalDateTime);
                                segment.DepartureDateTime = new Date(segment.DepartureDateTime);
                                return segment;
                            } );
                        itinerary.numOfOutboundStops = itinerary.OutboundLeg.Stops.length;
                        itinerary.numOfInboundStops  = itinerary.InboundLeg ? itinerary.InboundLeg.Stops.length : 0;
                        const maxNumOfStops          = itinerary.numOfOutboundStops > itinerary.numOfInboundStops ? itinerary.numOfOutboundStops : itinerary.numOfInboundStops;
                        itinerary.maxNumOfStops      = maxNumOfStops > 2 ? 2 : maxNumOfStops;

                        this.availabledStops[itinerary.maxNumOfStops] = true;

                        itinerary.onlyCarrierId = itinerary.OutboundLeg.Carriers
                                                           .concat(itinerary.InboundLeg ? itinerary.InboundLeg.Carriers : [])
                                                           .reduce( ( preOcId, oc ) => preOcId !== null && preOcId === oc.Id ? preOcId : null , itinerary.OutboundLeg.Carriers[0].Id );

                        const lowestGroupPrice = Math.min.apply(null, itinerary.PricingOptions.map( po => po.Price ));
                        itinerary.lowestPrice = Math.ceil( lowestGroupPrice / numOfPassengers );
                        itinerary.averageDuration = ( itinerary.OutboundLeg.Duration + ( itinerary.InboundLeg ? itinerary.InboundLeg.Duration : 0 ) ) / ( isOneWay ? 1 : 2 );
                        return itinerary;
                    });

                    this.carriersMap = Object.values(result.data.carriers)
                                             .map( carrier => {

                                                 carrier.cheapestItinerary = this.itineraries.filter(function(itinerary){

                                                    return itinerary.OutboundLeg.Carriers
                                                                    .concat(itinerary.InboundLeg ? itinerary.InboundLeg.Carriers : [])
                                                                    .every( oc => oc.Id === carrier.Id );

                                                 }).reduce((cheapestItinerary, itinerary) => !cheapestItinerary || itinerary.lowestPrice < cheapestItinerary.lowestPrice ? itinerary : cheapestItinerary, null);

                                                 return carrier;

                                             } );


                    this.carriersMap.push({
                        Code: null,
                        DisplayCode: null,
                        Id: 0,
                        ImageUrl: null,
                        Name: '航空公司組合',
                        cheapestItinerary: this.itineraries
                                            .filter( itinerary => !itinerary.onlyCarrierId )
                                            .reduce((cheapestItinerary, itinerary) => !cheapestItinerary || itinerary.lowestPrice < cheapestItinerary.lowestPrice ? itinerary : cheapestItinerary, null)
                    });

                    this.selectedCarriers = Object.values(this.carriersWithCheapestItinerary).map( carrier => carrier.Id );
               })
               .catch(err => {
                   if(err.response && err.response.status === 302 && err.response.data.live_price ){
                       const livePrice = err.response.data.live_price;
                       this.$router.push({ path: `/search/${livePrice}` });
                       return this.getResult(parseInt(this.$route.params.session))
                   }
                   this.errorMessages.push('查詢價格時發生錯誤，請稍後再嘗試。');
                   console.log(err, err.response);
               } );
      },
      transformDateToHi(date){
          const h = date.getHours();
          const m = date.getMinutes();
          return `${ h >= 10 ? h : ( '0' + h ) }:${ m >= 10 ? m : ( '0' + m ) }`;
      },
      showItineraryDetail(itinerary){
          this.detailedItinerary = itinerary;
          this.detailShown = true;
      },

      closeDetail(){
          this.detailShown = false;
          this.detailedItinerary = {};
          this.detail.OutboundSegmentShown = false;
          this.detail.InboundSegmentShown  = false;
          this.detail.infoBeforeOrderShown = false;
      },

      translateDay(day){
          const map = {
              0:'日',
              1:'一',
              2:'二',
              3:'三',
              4:'四',
              5:'五',
              6:'六',
          };
          return map[day];
      }

  }
}

</script>

<style>
</style>
